import React, { useState, useEffect } from 'react';
import axios from 'axios';
import FornecedorPicker from './FornecedorPicker';
import ElementoDespesaPicker from './ElementoDespesaPicker';
import SubelementoDespesaPicker from './SubelementoDespesaPicker';
import AcaoGovernamentalPicker from './AcaoGovernamentalPicker';
import FonteRecursoPicker from './FonteRecursoPicker';
import DescricaoEntregaPicker from './DescricaoEntregaPicker';
import * as DescricaoEntregaApi from '../../DescricaoEntregaService';
import { API_BASE_URL } from '../../../config/ApiConfig';
import DefaultModal from './DefaultModal';
import useDefaultModal from '../hooks/useDefaultModal';
import useParametrosEntidade from '../hooks/useParametrosEntidade';
import DataMaskInput from '../masks/DataMaskInput';

function CompraDiretaModal({ show, compra, onClose, onSave }) {
  const anoBase = parseInt(localStorage.getItem('anoBase'), 10) || new Date().getFullYear();
  const [formData, setFormData] = useState({
    idFornecedor: '',
    data: '',
    objeto: '',
    idAcaoGovernamental: '',
    idElementoDespesa: '',
    idSubelementoDespesa: '',
    idFonteRecurso: '',
    idProprio: '',
    descricaoEntrega: '',
  });
  const [fornecedores, setFornecedores] = useState([]);
  const [elementosDespesa, setElementosDespesa] = useState([]);
  const [subelementosDespesa, setSubelementosDespesa] = useState([]);
  const [acoesGovernamentais, setAcoesGovernamentais] = useState([]);
  const [fontesRecurso, setFontesRecurso] = useState([]);
  const [showFornecedorPicker, setShowFornecedorPicker] = useState(false);
  const [showElementoDespesaPicker, setShowElementoDespesaPicker] = useState(false);
  const [showSubelementoDespesaPicker, setShowSubelementoDespesaPicker] = useState(false);
  const [showAcaoGovernamentalPicker, setShowAcaoGovernamentalPicker] = useState(false);
  const [showFonteRecursoPicker, setShowFonteRecursoPicker] = useState(false);
  const [showDescricaoPicker, setShowDescricaoPicker] = useState(false);
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem('token');
  const vinculo = JSON.parse(localStorage.getItem('vinculo'));
  const user = JSON.parse(localStorage.getItem('user'));
  const { setDefaultModal, showDefaultModal } = useDefaultModal();
  const { params: paramsEntidade } = useParametrosEntidade(vinculo?.idEntidade);

  useEffect(() => {
    if (show) {
      const headers = { Authorization: `Bearer ${token}` };

      axios.get(`${API_BASE_URL.FORNECEDOR}/entidade/${vinculo.idEntidade}`, { headers })
        .then(result => setFornecedores(result.data))
        .catch(error => console.error('Erro ao carregar fornecedores:', error));

      axios.get(API_BASE_URL.ELEMENTO_DESPESA, { headers })
        .then(result => setElementosDespesa(result.data))
        .catch(error => console.error('Erro ao carregar elementos de despesa:', error));

      axios.get(`${API_BASE_URL.ACAO_GOVERNAMENTAL}/entidade/${vinculo.idEntidade}`, { headers })
        .then(result => setAcoesGovernamentais(result.data))
        .catch(error => console.error('Erro ao carregar ações governamentais:', error));

      axios.get(`${API_BASE_URL.FONTE_RECURSO}/entidade/${vinculo.idEntidade}`, { headers })
        .then(result => setFontesRecurso(result.data))
        .catch(error => console.error('Erro ao carregar fontes de recurso:', error));

      if (compra) {
        const formatDate = date => {
          if (!date) return '';
          if (Array.isArray(date)) {
            const [year, month, day] = date;
            return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
          }
          if (typeof date === 'string') return date.split('T')[0];
          return '';
        };
        setFormData({
          idFornecedor: compra.idFornecedor || '',
          data: formatDate(compra.data),
          objeto: compra.objeto || '',
          idAcaoGovernamental: compra.idAcaoGovernamental || '',
          idElementoDespesa: compra.idElementoDespesa || '',
          idSubelementoDespesa: compra.idSubelementoDespesa || '',
          idFonteRecurso: compra.idFonteRecurso || '',
          idProprio: compra.idProprio || '',
          descricaoEntrega: compra.descricaoEntrega || '',
        });

        if (compra.idElementoDespesa) {
          axios.get(`${API_BASE_URL.SUBELEMENTO_DESPESA}/elemento/${compra.idElementoDespesa}`, { headers })
            .then(result => setSubelementosDespesa(result.data))
            .catch(error => console.error('Erro ao carregar subelementos:', error));
        }

        DescricaoEntregaApi.getList(vinculo.idEntidade)
          .then(list => {
            if (Array.isArray(list) && list.length === 1) {
              setFormData(prev => ({ ...prev, descricaoEntrega: list[0].descricao }));
            }
          })
          .catch(err => console.error('Erro ao carregar descrições (auto):', err));
      } else {
        setFormData({
          idFornecedor: '',
          data: '',
          objeto: '',
          idAcaoGovernamental: '',
          idElementoDespesa: '',
          idSubelementoDespesa: '',
          idFonteRecurso: '',
          idProprio: '',
          descricaoEntrega: '',
        });
        setSubelementosDespesa([]);
      }
      setValidated(false);
    }
  }, [show, compra, token]);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFornecedorSelect = (fornecedor) => {
    setFormData(prev => ({ ...prev, idFornecedor: fornecedor.idFornecedor }));
    setShowFornecedorPicker(false);
  };

  const handleElementoDespesaSelect = (elemento) => {
    setFormData(prev => ({ ...prev, idElementoDespesa: elemento.codigo, idSubelementoDespesa: '' }));
    setShowElementoDespesaPicker(false);

    const headers = { Authorization: `Bearer ${token}` };
    axios.get(`${API_BASE_URL.SUBELEMENTO_DESPESA}/elemento/${elemento.codigo}`, { headers })
      .then(result => setSubelementosDespesa(result.data))
      .catch(error => console.error('Erro ao carregar subelementos:', error));
  };

  const handleSubelementoDespesaSelect = (subelemento) => {
    setFormData(prev => ({ ...prev, idSubelementoDespesa: subelemento.codigo }));
    setShowSubelementoDespesaPicker(false);
  };

  const handleAcaoGovernamentalSelect = (acao) => {
    setFormData(prev => ({ ...prev, idAcaoGovernamental: acao.codigo }));
    setShowAcaoGovernamentalPicker(false);
  };

  const handleFonteRecursoSelect = (fonte) => {
    setFormData(prev => ({ ...prev, idFonteRecurso: fonte.codigo }));
    setShowFonteRecursoPicker(false);
  };

  const handleDescricaoSelect = (descricao) => {
    setFormData(prev => ({ ...prev, descricaoEntrega: descricao }));
    setShowDescricaoPicker(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setValidated(true);
    if (!formData.idFornecedor || !formData.data) return;
    setLoading(true);

    const payload = {
      ...formData,
      idElementoDespesa: formData.idElementoDespesa || null,
      idSubelementoDespesa: formData.idSubelementoDespesa || null,
      idAcaoGovernamental: formData.idAcaoGovernamental || null,
      idFonteRecurso: formData.idFonteRecurso || null,
      ano: anoBase,
      idEntidade: vinculo.idEntidade,
      usuario: user?.login || '',
    };
    if (compra?.id) payload.id = compra.id;

    try {
      if (compra?.id) {
        await axios.put(`${API_BASE_URL.COMPRA_DIRETA}/${compra.id}`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });

        try {
          const preRes = await axios.get(`${API_BASE_URL.PRE_EMPENHO}/por-vinculo`, {
            params: { tipoVinculo: 'COMPRA_DIRETA', idVinculo: compra.id },
            headers: { Authorization: `Bearer ${token}` },
          });
          if (preRes.data?.id) {
            const prePayload = {
              ...preRes.data,
              dataEmissao: payload.data || preRes.data.dataEmissao,
              objeto: payload.objeto || preRes.data.objeto,
              idFornecedor: payload.idFornecedor || preRes.data.idFornecedor,
              usuario: user?.login || '',
            };
            await axios.put(`${API_BASE_URL.PRE_EMPENHO}/${preRes.data.id}`, prePayload, {
              headers: { Authorization: `Bearer ${token}` },
            });
          }
        } catch (_) {}
      } else {
        await axios.post(API_BASE_URL.COMPRA_DIRETA, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
      }
      if (onSave) onSave();
      if (onClose) onClose();
      showDefaultModal('success', compra ? 'Compra Direta atualizada com sucesso!' : 'Compra Direta cadastrada com sucesso!');
    } catch (error) {
      console.error('Erro ao salvar Compra Direta:', error);
      const msg = error?.response?.data?.error || 'Erro ao salvar Compra Direta. Verifique os dados e tente novamente.';
      showDefaultModal('error', msg);
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;

  return (
    <>
      <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
        <div className="modal-dialog modal-lg" style={{height: '90vh' }}>
          <div className="modal-content h-100 overflow-hidden">
            <div
              className="modal-header text-white"
              style={{
                background: 'linear-gradient(45deg, rgb(7, 29, 65) 0%, rgba(29, 100, 216, 1) 100%)',
                padding: '0.5rem 1rem',
                borderTopLeftRadius: '0.5rem',
                borderTopRightRadius: '0.5rem',
                border: 'none',
              }}
            >
              <h6 className="modal-title mb-0">
                <i className="bi bi-cart3 me-2"></i>
                {compra ? 'Editar Compra Direta' : 'Nova Compra Direta'}
              </h6>
              <button type="button" className="btn-close btn-close-white" onClick={onClose} disabled={loading} title="Fechar"></button>
            </div>
            <div className="modal-body" style={{ overflowY: 'auto' }}>
              <form onSubmit={handleSubmit} noValidate>
                <div className="row">
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label small fw-semibold">Nº Compra</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={compra?.numCompra || 'Auto-gerado'}
                        readOnly
                        disabled
                      />
                    </div>
                  </div>
                  {paramsEntidade.EDITAR_ID_PROPRIO !== 'N' && (
                    <div className="col-md-4">
                      <div className="mb-3">
                        <label className="form-label small fw-semibold">Nº Próprio</label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          name="idProprio"
                          value={formData.idProprio}
                          onChange={handleChange}
                          maxLength={20}
                          disabled={loading}
                          placeholder="Ex: CD001/2024"
                        />
                      </div>
                    </div>
                  )}
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label small fw-semibold">Data <span className="text-danger">*</span></label>
                      <DataMaskInput name="data" value={formData.data} onChange={handleChange} disabled={loading} className={validated && !formData.data ? 'is-invalid' : ''} />
                    </div>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label small fw-semibold">Fornecedor <span className="text-danger">*</span></label>
                  <div className="input-group input-group-sm">
                    <input
                      type="text"
                      className={`form-control ${validated && !formData.idFornecedor ? 'is-invalid' : ''}`}
                      value={
                        fornecedores.find(f => f.idFornecedor === formData.idFornecedor)
                          ? `${fornecedores.find(f => f.idFornecedor === formData.idFornecedor).nome} - ${fornecedores.find(f => f.idFornecedor === formData.idFornecedor).cpfOrCnpj}`
                          : ''
                      }
                      placeholder="Clique para buscar o fornecedor..."
                      readOnly
                      disabled={loading}
                    />
                    <button type="button" className="btn btn-outline-secondary" onClick={() => setShowFornecedorPicker(true)} disabled={loading}>
                      <i className="bi bi-search"></i>
                    </button>
                    {formData.idFornecedor && (
                      <button type="button" className="btn btn-outline-danger" onClick={() => setFormData(prev => ({ ...prev, idFornecedor: '' }))} disabled={loading}>
                        <i className="bi bi-x"></i>
                      </button>
                    )}
                    <FornecedorPicker
                      show={showFornecedorPicker}
                      fornecedores={fornecedores}
                      selectedId={formData.idFornecedor}
                      onSelect={handleFornecedorSelect}
                      onClose={() => setShowFornecedorPicker(false)}
                    />
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label small fw-semibold">Objeto</label>
                  <textarea
                    className="form-control form-control-sm"
                    rows={3}
                    name="objeto"
                    value={formData.objeto}
                    onChange={handleChange}
                  placeholder="Descreva o objeto da compra..."
                  disabled={loading}
                />
              </div>

              <div className="mb-3">
                <label className="form-label small fw-semibold">Descrição de Entrega</label>
                <div className="d-flex">
                  <textarea
                    className="form-control flex-grow-1"
                    name="descricaoEntrega"
                    value={formData.descricaoEntrega}
                    onChange={handleChange}
                    rows={2}
                    disabled={loading}
                    placeholder="Descrição da entrega (ex: Imediata, 30 dias, etc.)"
                  />
                  <div className="d-flex flex-column ms-2">
                    <button
                      type="button"
                      className="btn btn-outline-secondary btn-sm mb-2"
                      style={{ height: '32px', paddingTop: '4px', paddingBottom: '4px' }}
                      onClick={() => setShowDescricaoPicker(true)}
                      disabled={loading}
                    >
                      <i className="bi bi-search"></i>
                    </button>
                    {formData.descricaoEntrega && (
                      <button
                        type="button"
                        className="btn btn-outline-danger btn-sm"
                        style={{ height: '32px', paddingTop: '4px', paddingBottom: '4px' }}
                        onClick={() => setFormData(prev => ({ ...prev, descricaoEntrega: '' }))}
                        disabled={loading}
                      >
                        <i className="bi bi-x"></i>
                      </button>
                    )}
                  </div>
                </div>
              </div>

              <hr className="my-3" />
                <h6 className="fw-semibold mb-3">Classificações Orçamentárias</h6>

                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label small fw-semibold">Ação Governamental</label>
                      <div className="input-group input-group-sm">
                        <input
                          type="text"
                          className="form-control"
                          value={
                            acoesGovernamentais.find(a => a.codigo === formData.idAcaoGovernamental)?.descricao
                              ? `${acoesGovernamentais.find(a => a.codigo === formData.idAcaoGovernamental).descricao} - ${formData.idAcaoGovernamental}`
                              : ''
                          }
                          placeholder="Clique para buscar..."
                          readOnly
                          disabled={loading}
                        />
                        <button type="button" className="btn btn-outline-secondary" onClick={() => setShowAcaoGovernamentalPicker(true)} disabled={loading}>
                          <i className="bi bi-search"></i>
                        </button>
                        {formData.idAcaoGovernamental && (
                          <button type="button" className="btn btn-outline-danger" onClick={() => setFormData(prev => ({ ...prev, idAcaoGovernamental: '' }))} disabled={loading}>
                            <i className="bi bi-x"></i>
                          </button>
                        )}
                        <AcaoGovernamentalPicker
                          show={showAcaoGovernamentalPicker}
                          acoes={acoesGovernamentais}
                          selectedCodigo={formData.idAcaoGovernamental}
                          onSelect={handleAcaoGovernamentalSelect}
                          onClose={() => setShowAcaoGovernamentalPicker(false)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label small fw-semibold">Fonte de Recurso</label>
                      <div className="input-group input-group-sm">
                        <input
                          type="text"
                          className="form-control"
                          value={
                            fontesRecurso.find(f => f.codigo === formData.idFonteRecurso)?.descricao
                              ? `${fontesRecurso.find(f => f.codigo === formData.idFonteRecurso).descricao} - ${formData.idFonteRecurso}`
                              : ''
                          }
                          placeholder="Clique para buscar..."
                          readOnly
                          disabled={loading}
                        />
                        <button type="button" className="btn btn-outline-secondary" onClick={() => setShowFonteRecursoPicker(true)} disabled={loading}>
                          <i className="bi bi-search"></i>
                        </button>
                        {formData.idFonteRecurso && (
                          <button type="button" className="btn btn-outline-danger" onClick={() => setFormData(prev => ({ ...prev, idFonteRecurso: '' }))} disabled={loading}>
                            <i className="bi bi-x"></i>
                          </button>
                        )}
                        <FonteRecursoPicker
                          show={showFonteRecursoPicker}
                          fontes={fontesRecurso}
                          selectedCodigo={formData.idFonteRecurso}
                          onSelect={handleFonteRecursoSelect}
                          onClose={() => setShowFonteRecursoPicker(false)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label small fw-semibold">Elemento de Despesa</label>
                      <div className="input-group input-group-sm">
                        <input
                          type="text"
                          className="form-control"
                          value={
                            elementosDespesa.find(e => e.codigo === formData.idElementoDespesa)?.descricao
                              ? `${elementosDespesa.find(e => e.codigo === formData.idElementoDespesa).descricao} - ${formData.idElementoDespesa}`
                              : ''
                          }
                          placeholder="Clique para buscar..."
                          readOnly
                          disabled={loading}
                        />
                        <button type="button" className="btn btn-outline-secondary" onClick={() => setShowElementoDespesaPicker(true)} disabled={loading}>
                          <i className="bi bi-search"></i>
                        </button>
                        {formData.idElementoDespesa && (
                          <button type="button" className="btn btn-outline-danger" onClick={() => setFormData(prev => ({ ...prev, idElementoDespesa: '', idSubelementoDespesa: '' }))} disabled={loading}>
                            <i className="bi bi-x"></i>
                          </button>
                        )}
                        <ElementoDespesaPicker
                          show={showElementoDespesaPicker}
                          elementos={elementosDespesa}
                          selectedCodigo={formData.idElementoDespesa}
                          onSelect={handleElementoDespesaSelect}
                          onClose={() => setShowElementoDespesaPicker(false)}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label small fw-semibold">Subelemento de Despesa</label>
                      <div className="input-group input-group-sm">
                        <input
                          type="text"
                          className="form-control"
                          value={
                            subelementosDespesa.find(s => s.codigo === formData.idSubelementoDespesa)?.descricao
                              ? `${subelementosDespesa.find(s => s.codigo === formData.idSubelementoDespesa).descricao} - ${formData.idSubelementoDespesa}`
                              : ''
                          }
                          placeholder={formData.idElementoDespesa ? 'Clique para buscar...' : 'Selecione um elemento primeiro'}
                          readOnly
                          disabled={loading || !formData.idElementoDespesa}
                        />
                        <button type="button" className="btn btn-outline-secondary" onClick={() => setShowSubelementoDespesaPicker(true)} disabled={loading || !formData.idElementoDespesa}>
                          <i className="bi bi-search"></i>
                        </button>
                        {formData.idSubelementoDespesa && (
                          <button type="button" className="btn btn-outline-danger" onClick={() => setFormData(prev => ({ ...prev, idSubelementoDespesa: '' }))} disabled={loading}>
                            <i className="bi bi-x"></i>
                          </button>
                        )}
                        <SubelementoDespesaPicker
                          show={showSubelementoDespesaPicker}
                          subelementos={subelementosDespesa}
                          selectedCodigo={formData.idSubelementoDespesa}
                          onSelect={handleSubelementoDespesaSelect}
                          onClose={() => setShowSubelementoDespesaPicker(false)}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <DescricaoEntregaPicker show={showDescricaoPicker} onClose={() => setShowDescricaoPicker(false)} onSelect={handleDescricaoSelect} />

              </form>
            </div>
            <div className="modal-footer" style={{ padding: '0.5rem 1rem' }}>
              <button type="button" className="btn btn-secondary" onClick={onClose} disabled={loading}>
                <i className="bi bi-x-circle me-1"></i>Cancelar
              </button>
              <button type="submit" className="btn btn-primary" onClick={handleSubmit} disabled={loading}>
                {loading ? (
                  <><span className="spinner-border spinner-border-sm me-1"></span>Salvando...</>
                ) : (
                  <><i className="bi bi-check-circle me-1"></i>Salvar</>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
      <DefaultModal {...setDefaultModal} />
    </>
  );
}

export default CompraDiretaModal;
